import { Link } from 'react-router-dom';
import { ArrowRight, Target, TrendingUp } from 'lucide-react';

const NAMES = {
  career_direction: 'Career Direction',
  profile_strength: 'Profile Strength',
  interview_readiness: 'Interview Readiness',
  job_search: 'Job Search Readiness',
};

const NEXT_STEP = {
  career_direction: { program: 'Career Direction Blueprint', focus: 'comparing realistic roles and choosing a direction you can test' },
  profile_strength: { program: 'Role Skills Execution', focus: 'building practical work samples that show your skills' },
  interview_readiness: { program: 'Career Readiness Program', focus: 'structured interview practice and presenting your work' },
  job_search: { program: 'Career Readiness Program', focus: 'targeting the right opportunities and tailoring your applications' },
};

const join = (keys) => keys.map((k) => NAMES[k]).join(' & ');

const InsightCard = ({ icon: Icon, label, value, testId }) => (
  <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm" data-testid={testId}>
    <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-teal-700"><Icon className="w-4 h-4" />{label}</div>
    <p className="text-lg font-bold text-slate-900 mt-2">{value}</p>
  </div>
);

export const ReadinessInsights = ({ results }) => {
  const tied = results.tiedDimensions || [results.priorityArea];
  const strongest = results.strongestAreas || [];
  return (
    <div className="grid sm:grid-cols-2 gap-4 mb-8">
      <InsightCard icon={TrendingUp} testId="results-strongest-area" label={strongest.length > 1 ? 'Joint strongest areas' : 'Strongest area'}
        value={strongest.length ? join(strongest) : 'Even across all four areas'} />
      <InsightCard icon={Target} testId="results-improvement-area" label={tied.length > 1 ? 'Joint priority areas' : 'Primary improvement area'}
        value={join(tied)} />
    </div>
  );
};

export const ReadinessNextStep = ({ area }) => {
  const step = NEXT_STEP[area];
  return (
    <div className="border border-slate-200 rounded-2xl p-6 mb-8" data-testid="results-next-step-recommendation">
      <p className="text-xs font-semibold uppercase tracking-wider text-teal-700">Recommended next step</p>
      <p className="text-slate-700 mt-2 leading-relaxed">
        Start with a 1:1 Career Clarity Session to agree on your priorities. If you then want structured support, the{' '}
        <span className="font-semibold text-slate-900">{step.program}</span> focuses on {step.focus}.
      </p>
      <Link to="/programs" data-testid="results-see-programs-link" className="inline-flex items-center gap-1 text-sm font-semibold text-teal-700 hover:text-teal-800 mt-3">
        See programs <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};
